var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        width: "916px",
        height: "auto",
        top: "10vh",
        title: "",
        "show-close": _vm.showClose,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { staticClass: "video-name" }, [
          _vm._v(_vm._s(_vm.videoName)),
        ]),
      ]),
      _c("div", { staticClass: "choose_resource" }, [
        _vm.visible ? _c("div", { attrs: { id: "msg" } }) : _vm._e(),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      _c("div", { staticClass: "zimu_ls" }, [
        _c("span", [_vm._v(_vm._s(_vm.nowWzData))]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }